import request from '@/utils/request'

// 查询列表
export function apiInvCallRequestLinesList (data) {
  return request({
    url: '/inv/invCallRequestLines/list',
    method: 'post',
    data: data
  })
}

// 取消
export function apiInvCallRequestLinesCancellation (id) {
  return request({
    url: `/inv/invCallRequestLines/cancellation/${id}`,
    method: 'post'
  })
}

// 详情
export function apiInvCallRequestLinesObtainEditingData (id) {
  return request({
    url: `/inv/invCallRequestLines/obtainEditingData/${id}`,
    method: 'post'
  })
}

// 物料类别
export function apiScpMrpCategoryCodeCategoryBox (query) {
  return request({
    url: '/scp/scpMrpCategoryCode/categoryBox',
    method: 'get',
    params: query
  })
}

// 单位
export function apiInvCallRequestLinesPrimaryUomBox (query) {
  return request({
    url: '/inv/invCallRequestLines/primaryUomBox',
    method: 'get',
    params: query
  })
}

// 供应组织
export function apiUserInventOrgAll (query) {
  return request({
    url: '/system/user/inventOrgAll',
    method: 'get',
    params: query
  })
}

// 需求工单号
export function apiInvCallRequestLinesDemandWipEntityNameBox (query) {
  return request({
    url: '/inv/invCallRequestLines/demandWipEntityNameBox',
    method: 'get',
    params: query
  })
}

// 获取用户有的组织权限，排除产业园二期
export function getInfo2 () {
  return request({
    url: '/system/user/getInfo2',
    method: 'get'
  })
}

// 行删除
export function apiInvCallRequestLinesDelete (id) {
  return request({
    url: `/inv/invCallRequestLines/delete/${id}`,
    method: 'delete'
  })
}

// 整单删除
export function apiInvCallRequestLinesEntireDelete (id) {
  return request({
    url: `/inv/invCallRequestLines/entireDelete/${id}`,
    method: 'delete'
  })
}

// 保存
export function apiInvCallRequestLinesInsert (data) {
  return request({
    url: '/inv/invCallRequestLines/insert',
    method: 'put',
    data: data
  })
}

// 保存并发布
export function apiInvCallRequestLinesSavePublish (data) {
  return request({
    url: '/inv/invCallRequestLines/savePublish',
    method: 'put',
    data: data
  })
}

// 导出列表
export function apiInvCallRequestLinesExport (data) {
  return request({
    url: '/inv/invCallRequestLines/v2/export',
    method: 'post',
    data: data
  })
}

// 筛选方案列表
export function apiScpScreeningSchemeSearchAllScheme (query) {
  return request({
    url: '/scp/scpScreeningScheme/searchAllScheme',
    method: 'get',
    params: query
  })
}

// 五金叫料单打印
export function apiPrintWjCall (data) {
  return request({
    url: '/inv/invCallRequestLines/printWjCall',
    method: 'post',
    data: data
  })
}

// 叫料单打印
export function apiPrintCallNotice (data) {
  return request({
    url: '/inv/invCallRequestLines/printCallNotice',
    method: 'post',
    data: data
  })
}

// 五金叫料单批量打印
export function apiPrintWjCallBatch (data) {
  return request({
    url: '/inv/invCallRequestLines/printWjCallBatch',
    method: 'post',
    data: data
  })
}

// 叫料单批量打印
export function apiPrintCallNoticeBatch (data) {
  return request({
    url: '/inv/invCallRequestLines/printCallNoticeBatch',
    method: 'post',
    data: data
  })
}
